<div class="unlockAccount__body">
  <idp-login-header
    [loginHeaderContent]="pageData?.unlockYourAccountView"
  ></idp-login-header>
  <section
    class="unlockAccount__section--message"
    [innerHTML]="
      pageData.unlockYourAccountView.wifiPortal
        ? pageData?.unlockYourAccountView.message.wfp
        : pageData?.unlockYourAccountView.message.modal
    "
  ></section>
  <div
    class="unlockAccount__cta--reset-button"
    [ngClass]="{ wifiPortal: pageData.unlockYourAccountView.wifiPortal }"
  >
    <idp-button
      [label]="
        pageData?.unlockYourAccountView.nextDisplayView.button_resetPassword
      "
      [size]="'full-width'"
      (notify)="submitResetPassword()"
      [customClass]="'unlockAccountButton'"
    ></idp-button>
  </div>
  <div
    class="unlockAccount__cta--help-button"
    [ngClass]="{ wifiPortal: pageData.unlockYourAccountView.wifiPortal }"
  >
    <idp-button
      [label]="pageData?.unlockYourAccountView.nextDisplayView.button_loginHelp"
      [size]="'full-width'"
      (notify)="submitLoginHelp()"
    ></idp-button>
  </div>
</div>
